function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "group",
  transform: "translate(8.000000, 8.000000) scale(-1, 1) translate(-8.000000, -8.000000) ",
  fill: "#636363"
}, React.createElement("g", {
  id: "Group-7"
}, React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 7.11111111,
  height: 7.11111111,
  rx: 1
}), React.createElement("rect", {
  id: "Rectangle-Copy-2",
  x: 0,
  y: 8.88888889,
  width: 7.11111111,
  height: 7.11111111,
  rx: 1
}), React.createElement("rect", {
  id: "Rectangle-Copy",
  x: 8.88888889,
  y: 0,
  width: 7.11111111,
  height: 7.11111111,
  rx: 1
}), React.createElement("rect", {
  id: "Rectangle-Copy-26",
  x: 8.88888889,
  y: 8.88888889,
  width: 7.11111111,
  height: 7.11111111,
  rx: 1
}))));

var SvgGroup = function SvgGroup(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGroup, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/group.599d946b.svg";
export { ForwardRef as ReactComponent };